// `dish` , the standard restaurant/café item. The baseline: no extra structure,
// profile is always `{}`. Every pre-existing menu_items row is a dish, so this is
// the non-destructive control (doc 38 Part 1, mirroring doc 33's `standard` type).

import { z } from 'zod';

import type { ItemKindDefinition } from './registry-types';
import type { DishProfile } from './types';

// `.strip()` drops any stray keys so a dish profile can never accrete structure.
export const DishProfileSchema = z.object({}).strip();

export const dishKind: ItemKindDefinition<DishProfile> = {
  id: 'dish',
  label: 'Dish',
  noun: 'dish',
  description: 'A standard menu item with one price.',
  defaultPricingMode: 'flat',
  allowedPricingModes: ['flat', 'per_unit_weight'],
  schema: DishProfileSchema as unknown as z.ZodType<DishProfile>,
  defaultProfile: () => ({}) as DishProfile,
};
